import { useState } from "react";
import { createModel } from "hox";
import useStorageState from "../hooks/useStorageState";
import { PaginationProps } from "antd/es/pagination";
import { customerService } from "@/views/base/customer/customerService";
import { supplierService } from "@/views/base/supplier/supplierService";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { defaultMdCmParam } from "@/utils/constants";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { IPgProps, ISelectOptions } from "@/types/AppTypes";
import { offerService } from "@/views/inquires/offer/offerService";
import { salesService } from "@/views/sales/salesService";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}
export function transPgToPaginationTotal(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}

export function fn(): Promise<ISelectOption[]> {
    let arr: ISelectOption[] = [];
    return Promise.resolve(arr)
}

export type RoleType = {
    id: string,
    name: String,
};
export type UserType = {
    id: string,
    userName: string,
    password: String,
    token: string,
    shopId: string,
    shopName: string,
    shopCode: string,
    loginType?: "account" | "token"
    [key: string]: any
}

export type LoadingType = { loadingVisible: boolean, txt: string };

type GlobalModelType = {
    user: UserType,
    setUser: (e: UserType) => void,
    resetUser: () => void,
    toggleMenu: () => void,
    cm: CmType,
    resetCm: () => void,
    loadingInfo: LoadingType,
    setLoadingInfo: (origin: LoadingType) => void,

    whDs: ISelectOptions[],
    warehouseloadDataAll: (shopCode?: string) => void,

    // beDs: ISelectOptions[],
    // beLoadDataAll: () => void,
    requestCacheAll: (shopCode?: string) => void,

    beShopDs: ISelectOptions[],
    setBeShopDs: (value: ISelectOptions[] | ((previousState?: ISelectOptions[] | undefined) => ISelectOptions[])) => void

    shopDs: ISelectOptions[],
    setShopDs: (origin: ISelectOptions[]) => void

    supplierDs: ISelectOptions[],
    supplierLoadDataAll: (shopCode?: string) => void,

    resourceAuth: string[],
    setResourceAuth: (origin: string[]) => void

    menuAuth: string[],
    setMenuAuth: (origin: string[]) => void,

    isEditable:boolean,
    setIsEditable:(origin: boolean) => void,

    isApproveEditable:boolean,
    setIsApproveEditable:(origin: boolean) => void,

    fetchCustomerList: (value: string) => Promise<ISelectOption[]>,
    fetchSupplierList: (value: string) => Promise<ISelectOption[]>,
    fetchOfferList: (value: string) => Promise<ISelectOption[]>,
    fetchSalesList: (value: string) => Promise<ISelectOption[]>,
    fetchSaleBySupplier: (value: string) => Promise<ISelectOption[]>,
};


const initUserState = {
    id: "",
    userName: "",
    password: "",
    token: "",
    shopId: "",
    shopName: "",
    shopCode: ""
}

type CmType = {
    collapsed: boolean
}
const initCmState = {
    collapsed: false
}

function useModel(): GlobalModelType {
    //所有仓库
    const [whDs, setwhDs] = useStorageState<ISelectOptions[]>("gtm.waerhouseDs", []);
    //对应门店的经营实体
    const [beShopDs, setBeShopDs] = useStorageState<ISelectOptions[]>("gtm.beShopDs", []);
    //所有门店
    const [shopDs, setShopDs] = useStorageState<ISelectOptions[]>("gtm.shopDs", []);
    //用户所有菜单权限
    const [menuAuth, setMenuAuth] = useStorageState<string[]>("gtm.user.menus", []);
    //用户所有资源权限
    const [resourceAuth, setResourceAuth] = useStorageState<string[]>("gtm.user.resource", []);
    //用户所有信息
    const [user, setUser, resetUser] = useStorageState<UserType>('gtm.user', initUserState);
    // //所有供应商
    const [supplierDs, setSupplierDs] = useStorageState<ISelectOptions[]>("gtm.supplierDs", []);
    const [cm, setCm, resetCm] = useStorageState<CmType>('gtm.cm', initCmState);
  

    //全局loading
    const [loadingInfo, setLoadingInfo] = useState<LoadingType>({ loadingVisible: false, txt: "" });

     // 表单创建时间修改时间是否可编辑
     const [isEditable,setIsEditable] =useState<boolean>(true)

    // 审批时间是否可编辑
    const [isApproveEditable,setIsApproveEditable] =useState<boolean>(false)

    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }
    //初始页数
    const searchParams = { pageSize: -1, pageNum: 1 };

    //实时查询客户接口
    const fetchCustomerList = async (value: string) => {
        // if (!value) return await fn();
        let data = { pageSize: 15, pageNum: 1, shopCode: user.shopCode, name: value?.trim(), status: "1" };
        return customerService.page(data).then(res => {
            const { retData: { records } } = res;
            return records ? records.map(item => ({
                key: item.id,
                id: item.id,
                label: item.name,
                value: item.code,
            })) : [];
        })
    }

    //实时查询供应商接口
    const fetchSupplierList = async (value: string) => {
        // if (!value) return await fn();
        let data = { pageSize: 15, pageNum: 1, shopCode: user.shopCode, name: value?.trim(), status: "1" };
        return supplierService.page(data).then(res => {
            const { retData: { records } } = res;
            return records ? records.map(item => ({
                key: item.id,
                id: item.id,
                label: item.name,
                value: item.id,
            })) : [];
        })
    }
    //实时查询报价单接口
    const fetchOfferList = async (value: string) => {
        // if (!value) return await fn();
        let data = { pageSize: 15, pageNum: 1, shopCode: user.shopCode, code: value?.trim() };
        return offerService.page(data).then(res => {
            const { retData: { records } } = res;
            return records ? records.map(item => ({
                id: item.id,
                label: item.realCode ??'',
                value: item.code,
            })) : [];
        })
    }
    //实时根据供应商code查询外贸单列表
    const fetchSaleBySupplier = async (value: string) => {
        let data = { shopCode: user.shopCode, code: value?.trim() };
        return salesService.pageBySupplier(data).then(res => {
            const { retData } = res;
            return retData ? retData.map(item => ({
                id: item.id,
                label: item.code,
                value: item.code,
            })) : [];
        })
    }

    //实时查询外贸单接口
    const fetchSalesList = async (value: string) => {
        // if (!value) return await fn();
        let data = { pageSize: 15, pageNum: 1, shopCode: user.shopCode, code: value?.trim() };
        return salesService.page(data).then(res => {
            const { retData: { records } } = res;
            return records ? records.map(item => ({
                id: item.id,
                label: item.realCode ?? "",
                value: item.code,
            })) : [];
        })
    }

    // //初始所有仓库
    const warehouseloadDataAll = async (shopCode = user.shopCode) => {
        let { retData } = await warehouseService.page({ ...searchParams, shopCode });
        const { records } = retData;
        setwhDs(records.map((item) => ({
            id: item.id,
            label: item.name,
            value: item.code
        })));
    }

    // //初始供应商缓存
    const supplierLoadDataAll = async (shopCode = user.shopCode) => {
        let { retData } = await supplierService.page({ ...searchParams, shopCode }, { headers: { timeout: 30000 } });
        const { records } = retData;
        let supplierOptios = records.map(item => ({
            key: item.id,
            id: item.id,
            label: item.name,
            value: item.code,
        }));
        setSupplierDs(supplierOptios);
    }

    //所有缓存加载
    const requestCacheAll = (shopId = user.shopId) => {
        warehouseloadDataAll();
        supplierLoadDataAll()
    };

    return {
        isApproveEditable,setIsApproveEditable,
        isEditable,setIsEditable,
        user, setUser, resetUser,
        cm, toggleMenu, resetCm,
        loadingInfo, setLoadingInfo,
        whDs,
        requestCacheAll,
        supplierDs, supplierLoadDataAll,
        // beDs,
        beShopDs, setBeShopDs,
        shopDs, setShopDs,
        resourceAuth, setResourceAuth,
        menuAuth, setMenuAuth,
        warehouseloadDataAll,
        fetchCustomerList,
        fetchSupplierList,
        fetchOfferList,
        fetchSalesList,
        fetchSaleBySupplier
    };
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel;
